import React from "react";
import {
  SEO,
  PageLayout,
  Section,
  DynamicTiles,
  MultipleComponentIterator,
  Image,
  FishermanHeader,
  MarkdownContent,
  SlideReveal,
  FullImageCard,
  InternalLink,
  FishermanIcon,
  ContinuousScrollV2,
  multipleComponentIterator,
  WebsiteComponentInteractions,
  OutboundLink,
  BasicCarousel,
  componentIterator,
  Accordion,
  FadeReveal,
  Location,
  Phone,
  Email,
  HoursOfOperation,
  WebsiteComponentInteraction,
  ReviewV2,
  CustomerReviewModal,
} from "@bluefin/components";
import { Button, Grid, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  withNamedArgs,
  getBusinessFiles,
  getComponentInteractions,
} from "../utils/utils";
import {
  createServiceCategorySlug,
  createLocationSlug,
} from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      dynamicTilesComponent,
      allFishermanBusinessMenuCategory,
      allFishermanBusinessFile,
      bookingUrl,
      allFishermanBusinessLocation,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogImage={fishermanBusinessWebsitePage.seoOgImage}
          ogUrl={""}
        />
        <PageLayout hero={false} subfooter={false} className={"home-page"}>
          <Section className={"custom-hero-section"}>
            <DynamicTiles className={"custom-hero"}>
              <MultipleComponentIterator
                iterator={dynamicTilesComponent.childConfigurations}
                components={[
                  {
                    component: (
                      <DynamicTiles.Tile
                        imageProps={{ loadStrategy: "eager" }}
                      />
                    ),
                    propMap: {
                      images: "files",
                      content: "contentNodes",
                      interactions: "interactions",
                      className: "data.className",
                      overlayClassName: "data.overlayClassName",
                      width: "data.width",
                      video: "data.video",
                    },
                  },
                ]}
              />
            </DynamicTiles>
          </Section>
          <div className={"custom-image-banner-container"}>
            <Image
              centered={true}
              src={
                "https://fisherman.gumlet.io/public/ecced18a-ad62-4442-a99f-d512a28adaf5/Untitled_design_28_G4q7ydt.png"
              }
            />
          </div>
          <Section className={"custom-services services-section"} width={"16"}>
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_header",
                defaultValue: "Our Services",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
            />
            <Card.Group itemsPerRow={4}>
              <MultipleComponentIterator
                iterator={allFishermanBusinessMenuCategory.nodes}
                limit={8}
                components={[
                  {
                    component: (
                      <SlideReveal
                        className={"ui card"}
                        direction={"up"}
                        triggerOnce={true}
                        fade={true}
                      />
                    ),
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: (
                          <FullImageCard
                            as={InternalLink}
                            link={true}
                            event={{
                              category: "Services",
                              action: "View Category Details",
                            }}
                            className={"category-card"}
                          />
                        ),
                        propMap: {
                          image: withNamedArgs({
                            func: getBusinessFiles,
                            args: {
                              businessFiles: allFishermanBusinessFile.nodes,
                              numToSelect: 1,
                            },
                          }),
                          "event.label": "name",
                          to: createServiceCategorySlug,
                        },
                        children: [
                          {
                            component: <Card.Header />,
                            children: [
                              {
                                component: <span />,
                                propMap: { children: "name" },
                              },
                              {
                                component: (
                                  <FishermanIcon iconName={"arrow-right"} />
                                ),
                              },
                            ],
                          },
                          {
                            component: (
                              <MarkdownContent className={"description"} />
                            ),
                            propMap: { content: "description" },
                          },
                        ],
                      },
                    ],
                  },
                ]}
              />
            </Card.Group>
            <div className={"see-all-services-container"} />
          </Section>
          <Section className={"services-section"}>
            <ContinuousScrollV2
              multiplier={4}
              animationDurationSeconds={22}
              sizePatterns={[
                { width: "auto", height: 50, alignment: "middle" },
              ]}
              deviceSettings={{
                mobile: { elementWidth: "auto", gap: "0" },
                tablet: { elementWidth: "auto", gap: "0" },
                desktop: { elementWidth: "auto", gap: "0" },
              }}
              items={multipleComponentIterator({
                iterator: allFishermanBusinessMenuCategory.nodes,
                components: [
                  {
                    component: <ContinuousScrollV2.Item />,
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: (
                          <Button
                            event={{
                              category: "Services",
                              action: "View Category Details",
                            }}
                            as={InternalLink}
                          />
                        ),
                        propMap: {
                          "event.label": "name",
                          to: createServiceCategorySlug,
                          content: "name",
                        },
                      },
                    ],
                  },
                ],
              })}
            />
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_header",
                defaultValue: "Our Services",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
            />
            <WebsiteComponentInteractions
              alignment={"right"}
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
              fallback={
                <React.Fragment>
                  <Button
                    primary={true}
                    event={{
                      category: "Services",
                      action: "View All Services",
                    }}
                    as={InternalLink}
                    to={"/services/"}
                  >
                    <span
                      children={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "services_section_see_all_services_button",
                        defaultValue: "See All",
                      })}
                    />
                  </Button>
                  <Button
                    primary={true}
                    as={OutboundLink}
                    to={bookingUrl.url}
                    event={{
                      category: "Booking",
                      action: "Schedule Appointment Intent",
                    }}
                    content={bookingUrl.title}
                  />
                </React.Fragment>
              }
            />
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <BasicCarousel
                  size={1}
                  slide={true}
                  displayIndicators={false}
                  displayPlayPauseButton={false}
                  autoScroll={false}
                  leftArrowIcon={"arrow-left"}
                  rightArrowIcon={"arrow-right"}
                  mobile={{ size: 1 }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentIdentifier: "services_section_images",
                    }),
                    component: <Image background={true} />,
                    propMap: { src: "__all__" },
                  })}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <Accordion exclusive={true}>
                  <MultipleComponentIterator
                    iterator={allFishermanBusinessMenuCategory.nodes}
                    limit={6}
                    components={[
                      {
                        component: <React.Fragment />,
                        propMap: { key: "_id" },
                        children: [
                          {
                            component: (
                              <Accordion.Title
                                activeIcon={"minus"}
                                inactiveIcon={"plus"}
                              />
                            ),
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: (
                                  <SlideReveal
                                    fade={true}
                                    direction={"right"}
                                    firstAnimation={{ direction: "up" }}
                                  />
                                ),
                                children: [
                                  {
                                    component: <FishermanHeader as={"h3"} />,
                                    children: [
                                      {
                                        component: <span />,
                                        propMap: { children: "name" },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            component: <Accordion.Content />,
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: <MarkdownContent />,
                                propMap: { content: "description" },
                              },
                              {
                                component: (
                                  <Button
                                    content={"Options & Pricing >"}
                                    event={{
                                      category: "Services",
                                      action: "View Category Details",
                                    }}
                                    as={InternalLink}
                                  />
                                ),
                                propMap: {
                                  "event.label": "name",
                                  to: createServiceCategorySlug,
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ]}
                  />
                </Accordion>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"about-section"}>
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <Image
                    background={true}
                    className={"single-item-carousel-image"}
                    src={
                      "https://fisherman.gumlet.io/public/ecced18a-ad62-4442-a99f-d512a28adaf5/Untitled_design_DVMv80l.png"
                    }
                  />
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <div>
                    <FishermanHeader as={"h2"} content={"ABOUT US"} />
                    <FishermanHeader
                      as={"h3"}
                      content={"A Destination Designed for Escape"}
                    />
                    <div>
                      For over 50 years, Robert Andrew Salon & Spa has been a
                      premier destination for beauty, wellness, and relaxation.
                      Every detall-from our tranquil lounges and steam rooms to
                      our highly skilled providers-is designed to create an
                      experience that goes beyond the service.
                    </div>
                  </div>
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"book-now-section"}>
            <Image
              background={true}
              src={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentIdentifier: "book_now_section_background_image",
                numToSelect: 1,
              })}
            >
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "book_now_section_header",
                  defaultValue: "Book Your Appointment",
                })}
              />
              <MarkdownContent
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "book_now_section_description",
                  defaultValue: "",
                })}
              />
              <WebsiteComponentInteractions
                ctas={getComponentInteractions({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "book_now_section_description",
                })}
                alignment={"center"}
                fallback={
                  <React.Fragment>
                    <Button
                      primary={true}
                      as={OutboundLink}
                      to={bookingUrl.url}
                      event={{
                        category: "Booking",
                        action: "Schedule Appointment Intent",
                      }}
                      content={bookingUrl.title}
                    />
                  </React.Fragment>
                }
              />
            </Image>
          </Section>
          <Section className={"locations-section"}>
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "locations_section_header",
                defaultValue: "Our Beautiful Locations",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "locations_section_description",
              })}
            />
            <WebsiteComponentInteractions
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "locations_section_description",
              })}
            />
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <Accordion exclusive={true} defaultActiveIndexes={[0]}>
                  <MultipleComponentIterator
                    iterator={allFishermanBusinessLocation.nodes}
                    components={[
                      {
                        component: <React.Fragment />,
                        propMap: { key: "_id" },
                        children: [
                          {
                            component: (
                              <Accordion.Title
                                activeIcon={"minus"}
                                inactiveIcon={"plus"}
                              />
                            ),
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: (
                                  <SlideReveal
                                    fade={true}
                                    direction={"right"}
                                    firstAnimation={{ direction: "up" }}
                                  />
                                ),
                                children: [
                                  {
                                    component: <FishermanHeader as={"h3"} />,
                                    propMap: { content: "name" },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            component: <Accordion.Content />,
                            propMap: { index: "__itemIndex__" },
                            children: [
                              {
                                component: <div />,
                                children: [
                                  {
                                    component: (
                                      <div className={"information"} />
                                    ),
                                    children: [
                                      {
                                        component: <Location inline={true} />,
                                        propMap: {
                                          "address.street": "street",
                                          "address.city": "city",
                                          "address.state": "state",
                                          "address.zip": "zipCode",
                                        },
                                      },
                                      {
                                        component: <Phone />,
                                        propMap: { phone: "phoneNumber" },
                                      },
                                      {
                                        component: <Email />,
                                        propMap: { email: "email" },
                                      },
                                      {
                                        component: (
                                          <HoursOfOperation
                                            displayOption={"dailyWithPopup"}
                                            displayOpenClosedStatus={true}
                                            enhancedLabels={{
                                              openingSoon: "Opening soon",
                                              open: "Open now",
                                            }}
                                          />
                                        ),
                                        propMap: {
                                          hours: "hours",
                                          timezone: "timezone",
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    component: <div className={"ctas"} />,
                                    children: [
                                      {
                                        component: (
                                          <MultipleComponentIterator
                                            components={[
                                              {
                                                component: (
                                                  <WebsiteComponentInteraction
                                                    event={{
                                                      category: "Locations",
                                                      action:
                                                        "Location Interaction",
                                                    }}
                                                  />
                                                ),
                                                propMap: {
                                                  interaction: "__all__",
                                                },
                                              },
                                            ]}
                                          />
                                        ),
                                        propMap: { iterator: "interactions" },
                                      },
                                    ],
                                  },
                                ],
                              },
                              {
                                component: (
                                  <InternalLink
                                    className={"location-details"}
                                    label={"Location Details >"}
                                    event={{
                                      category: "Locations",
                                      action: "View Location Details",
                                    }}
                                  />
                                ),
                                propMap: {
                                  key: "_id",
                                  "event.label": "name",
                                  to: createLocationSlug,
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ]}
                  />
                </Accordion>
                <div className={"ctas-container"}>
                  <Button
                    primary={true}
                    as={InternalLink}
                    to={"/contact/"}
                    content={"Contact Us"}
                  />
                </div>
              </Grid.Column>
              <Grid.Column width={8}>
                <BasicCarousel
                  size={1}
                  slide={true}
                  displayIndicators={false}
                  displayPlayPauseButton={false}
                  autoScroll={false}
                  leftArrowIcon={"arrow-left"}
                  rightArrowIcon={"arrow-right"}
                  mobile={{ size: 1 }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentIdentifier: "locations_section_images",
                    }),
                    component: <Image background={true} />,
                    propMap: { src: "__all__" },
                  })}
                />
              </Grid.Column>
            </Grid>
          </Section>
          <div
            className={"elfsight-app-6d656352-6eeb-4213-b112-ec0763a7fefc"}
            data-elfsight-app-lazy={true}
          />
          <Section className={"reviews-section"}>
            <Image
              background={true}
              src={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentIdentifier: "reviews_section_background_image",
                numToSelect: 1,
              })}
            >
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "reviews_section_header",
                  defaultValue: "What Our Clients Say",
                })}
              />
              <BasicCarousel
                size={1}
                displayIndicators={true}
                stepSize={1}
                autoScroll={false}
                leftArrowIcon={"arrow-left"}
                rightArrowIcon={"arrow-right"}
                displayPlayPauseButton={false}
                slide={true}
                items={multipleComponentIterator({
                  iterator: fishermanBusiness.reviews,
                  components: [
                    {
                      component: <ReviewV2 />,
                      propMap: { key: "_id" },
                      children: [
                        {
                          component: <ReviewV2.Text charLimit={440} />,
                          propMap: { text: "text" },
                        },
                        {
                          component: <ReviewV2.Line />,
                          children: [
                            {
                              component: <ReviewV2.Rating />,
                              propMap: { rating: "rating" },
                            },
                            {
                              component: <ReviewV2.RatingLabel />,
                              propMap: { rating: "rating" },
                            },
                          ],
                        },
                        {
                          component: <ReviewV2.Line />,
                          children: [
                            {
                              component: <ReviewV2.Author />,
                              propMap: { author: "author" },
                            },
                            {
                              component: <ReviewV2.Source />,
                              propMap: { source: "source", link: "link" },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                })}
              />
              <CustomerReviewModal
                businessId={fishermanBusiness._id}
                locations={allFishermanBusinessLocation.nodes}
                businessType={fishermanBusiness.type}
                triggerButtonProps={{ secondary: true }}
                buttonText={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "reviews_section_submit_review_button",
                  defaultValue: "Submit Review",
                })}
              />
            </Image>
          </Section>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      reviews {
        _id
        author
        text
        source
        rating
        link
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          content
        }
        interactions {
          _id
          order
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
      }
      seoTitle
      seoOgImage {
        url
        alt
        type
      }
    }
    dynamicTilesComponent: fishermanWebsiteComponent(
      page: { pageType: { eq: "Home" } }
      fastId: { eq: "DynamicTiles" }
    ) {
      childConfigurations {
        data {
          className
          overlayClassName
          width
          video {
            videoId
            url
            source
            placeholder
          }
        }
        files {
          _id
          altText
          file
          order
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          _id
          content
          contentType
          contentName
          order
        }
        interactions {
          _id
          displayType
          behaviorType
          enabled
          label
          order
          style
          url
        }
      }
    }
    allFishermanBusinessMenuCategory(
      sort: { fields: [isFeatured, order], order: [DESC, ASC] }
    ) {
      nodes {
        _id
        name
        files
        description
        items
      }
    }
    allFishermanBusinessFile {
      nodes {
        _id
        file
        description
        gatsbyFile {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
    bookingUrl: fishermanBusinessWebsitePage(
      title: { regex: "/Book Now|Make An Appointment/" }
      pageType: { eq: "External" }
    ) {
      url
      title
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        state
        zipCode
        name
        phoneNumber
        email
        hours {
          open
          close
          day
          label
        }
        timezone
        interactions {
          _id
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
        primaryLocation
      }
    }
  }
`;
